// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bQfU","textarea":"styles_textarea__355rh"};